import styled from 'styled-components';
import { ListItemMixin } from '../../mixins/components/ListItemMixin';

/**
 * @since 8.14.0
 */
var ListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "ListItem",
  componentId: "c11n-8-107-0__sc-13rwu5a-0"
})(["", ""], ListItemMixin);
ListItem.displayName = 'ListItem';
ListItem.defaultProps = {
  paddingY: 'xs'
};

/** @component */
export { ListItem };